import { Spinner } from '@chakra-ui/react';
import { Text } from './text';
import { VStack } from './stack';
import HeaderNav from '../HeaderNav/HeaderNav';
import React, { ReactNode } from 'react';

const DEFAULT_MESSAGE = (
  <>
    Preparing the next screen,
    <br />
    please hold on.
  </>
);

type Props = {
  /** What the wait is for. Defaults to the generic wording. */
  message?: ReactNode;
};

export const LoadingScreen = ({ message = DEFAULT_MESSAGE }: Props) => {
  return (
    <VStack h={'100vh'}>
      <HeaderNav />

      <VStack
        alignItems={'center'}
        flex={1}
        justifyContent={'center'}
        data-testid={'loading-screen'}
      >
        <Text
          color={'secondary.200'}
          fontWeight={'normal'}
          mb={2}
          textAlign={'center'}
        >
          {message}
        </Text>
        <Spinner color={'secondary.200'} size={'sm'} />
      </VStack>
    </VStack>
  );
};
